import React from 'react';
import Sidebar from '../components/Sidebar';
import UserManager from '../components/UserManager';
import '../styles/OwnerDashboard.css';

export default function OwnerUsers() {
  return (
    <>
      <div className="dashboard-container">
        <Sidebar />
        <main className="dashboard-main">
          <header className="dashboard-header">
            <h1>Manage Users</h1>
            <p>Create, edit, and manage platform users</p>
          </header>
          <UserManager />
        </main>
      </div>
    </>
  );
}
